export class ServiceViewModel {
  constructor(service) {
    (this.name = service.name ? service.name : ''),
      (this.productCategory = service.category ? service.category : '');

    (this.id = service.id ? service.id : ''),
      (this.code = service.code ? service.code : ''),
      (this.amount = service.amount ? service.amount : ''),
      (this.remarks = service.remarks ? service.remarks : '');
    this.image = service.image ? service.image : '';
  }
}
